// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"0b222662","171":"b2659b74","453":"3b6e65ee","659":"52f17e4c"}[chunkId] + ".chunk.js";
};